import React, { useEffect, useRef, useState } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
export default function StripFilteredGalleryCarousel(props) {
    var fields = props.fields, children = props.children;
    var _a = useState(false), isNextDisabled = _a[0], setIsNextDisabled = _a[1];
    var _b = useState(true), isPrevDisabled = _b[0], setIsPrevDisabled = _b[1];
    var customCategories = fields.customCategories || [];
    var _c = useState(null), selectedType = _c[0], setSelectedType = _c[1];
    var TitleTag = (fields.titleTag || 'h1');
    var splideRef = useRef(null);
    var handlePrev = function () {
        if (splideRef.current) {
            splideRef.current.splide.go('<');
        }
    };
    var handleNext = function () {
        if (splideRef.current) {
            splideRef.current.splide.go('>');
        }
    };
    var filteredChildren = selectedType
        ? children.filter(function (child) {
            var experienceTypes = child.fields.experienceType.split('|');
            return experienceTypes.includes(selectedType);
        })
        : children;
    var categoriesWithExperiences = customCategories.filter(function (category) {
        return children.some(function (child) {
            var experienceTypes = child.fields.experienceType.split('|');
            return experienceTypes.includes(category.codeName);
        });
    });
    useEffect(function () {
        var _a;
        var splideInstance = (_a = splideRef.current) === null || _a === void 0 ? void 0 : _a.splide;
        if (splideInstance) {
            var updateButtons_1 = function () {
                console.log("update buttons: ", splideInstance, splideInstance.index, splideInstance.length);
                setIsPrevDisabled(splideInstance.index === 0);
                setIsNextDisabled(splideInstance.index === splideInstance.length - 1);
            };
            splideInstance.on('mounted move', updateButtons_1);
            updateButtons_1(); // Initial check
            return function () {
                splideInstance.off('mounted move', updateButtons_1);
            };
        }
    }, []);
    var carouselClassName = (isNextDisabled ? " next-disabled" : (isPrevDisabled ? " prev-disabled" : ""));
    return (React.createElement("div", { className: "strip spa-strip-carousel-experiences shadow-right "
            + fields.backgroundColor
            + (fields.imagePosition == "right" ? " image-on-right" : " image-on-left")
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col" }, fields.displayTitle && React.createElement(TitleTag, { className: "mb-5 " + fields.titleStyle, itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null)),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col col-lg-4" }, fields.content && React.createElement("div", { className: "descrition" }, fields.content))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("div", { className: "d-flex justify-content-between flex-wrap filters mt-4 mb-5" },
                        React.createElement("div", { className: "experience-type-buttons" },
                            React.createElement("button", { onClick: function () { return setSelectedType(null); }, className: selectedType === null ? 'active' : '' }, "All"),
                            categoriesWithExperiences.map(function (category, index) { return (React.createElement("button", { key: index, onClick: function () { return setSelectedType(category.codeName); }, className: selectedType === category.codeName ? 'active' : '' },
                                React.createElement("span", null, category.name),
                                " ",
                                React.createElement("sup", null, category.numberOfExperiences))); })),
                        React.createElement("div", { className: "navigation ms-auto" },
                            React.createElement("button", { className: "left-button", onClick: handlePrev, disabled: isPrevDisabled }, "Left"),
                            React.createElement("button", { className: "right-button", onClick: handleNext, disabled: isNextDisabled }, "Right"))))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" + carouselClassName },
                    React.createElement(Splide, { ref: splideRef, options: {
                            arrows: false,
                            pagination: false,
                            gap: '20px',
                            fixedWidth: '386px',
                            breakpoints: {
                                767: {
                                    gap: '10px',
                                    fixedWidth: '260px',
                                },
                                480: {
                                    fixedWidth: '100%',
                                }
                            },
                        } }, filteredChildren === null || filteredChildren === void 0 ? void 0 : filteredChildren.map(function (child, index) { return (React.createElement(SplideSlide, { key: index },
                        React.createElement("div", { className: "card" },
                            React.createElement("div", { className: "img-container mb-3" },
                                React.createElement("img", { src: child.fields.image, className: "img-fluid", alt: child.fields.image_description || '', title: child.fields.image_title || '' })),
                            React.createElement("div", { className: "text" },
                                React.createElement("h6", { className: "mb-1" }, child.fields.experienceName),
                                React.createElement("p", null, child.fields.location))))); })))))));
}
